import { COLORS } from '@/styles/colors';
import { ellipsis } from '@/styles/common';
import { flex } from '@/styles/layout';
import { bodySmall, poppinsMediumFont } from '@/styles/typography';
import styled from 'styled-components';

export const MoreSelectedBadge = styled.div`
  color: ${COLORS.black};
  background-color: ${COLORS.grey[400]};
  border-radius: 4px;
  padding: 2px 6px;
  ${poppinsMediumFont};
`;

export const ClearIndicatorWrapper = styled.div`
  padding: 10px;
`;

export const MultiSelectOptionWrapper = styled.div<{ isSelected: boolean }>`
  padding: 10px 16px;
  ${flex({ justifyContent: 'flex-start' })};
  gap: 12px;
  ${bodySmall};
  cursor: pointer;

  &:hover {
    background-color: ${COLORS.grey[200]};
  }

  ${({ isSelected }) =>
    isSelected &&
    `
      background-color: ${COLORS.grey[150]};
  `};
`;

export const OptionLabel = styled.div`
  ${ellipsis};
`;
